




































import {defineComponent, PropType, ref} from "@vue/composition-api";
import {HeaderMenuItem} from "@tool/tool.types";

export default defineComponent({
  props: {
    menuItems: {
      type: Array as PropType<HeaderMenuItem[]>,
      required: true
    },
    title: {
      type: String,
      default: 'Menu'
    }
  },
  setup() {
    const mobileNavOpen = ref(false);

    return {mobileNavOpen}
  }
});
